export default function Contact() {
  return (
    <section id="contact" className="py-16 px-4 bg-gradient-to-b from-cyan-50 to-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6">
          ご予約・<br className="md:hidden" />お問い合わせ方法
        </h2>
        <p className="text-center text-gray-700 text-lg mb-12 leading-relaxed">
          ご予約・ご相談は、<br className="md:hidden" />公式LINEから<br className="md:hidden" />お気軽にどうぞ。<br />
          InstagramのDM・<br className="md:hidden" />お電話でも<br className="md:hidden" />受け付けています。
        </p>

        {/* メインCTA: LINE */}
        <div className="mb-8">
          <a
            href="https://lin.ee/ltlhjZa"
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-[#06C755] hover:bg-[#05b34c] rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group"
          >
            <div className="flex flex-col md:flex-row items-center justify-center gap-6">
              <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full group-hover:scale-110 transition-transform duration-300">
                <i className="ri-line-fill text-5xl text-white"></i>
              </div>
              <div className="text-center md:text-left">
                <h3 className="text-2xl font-bold text-white mb-2">LINEで質問する</h3>
                <p className="text-white/90 mb-1">@474ygoji</p>
                <p className="text-sm text-white/80">写真を送ってのご相談もOK・24時間受付</p>
              </div>
            </div>
          </a>
        </div>

        {/* サブCTA: Instagram・電話 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Instagram */}
          <a
            href="https://www.instagram.com/air_clean.etajima/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-200 cursor-pointer group"
          >
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-gray-100 rounded-full flex-shrink-0 group-hover:bg-pink-50 transition-colors duration-300">
                <i className="ri-instagram-fill text-3xl text-pink-500"></i>
              </div>
              <div className="text-left">
                <h3 className="text-lg font-bold text-gray-900 mb-1">Instagram</h3>
                <p className="text-sm text-gray-600 font-normal leading-relaxed">作業風景や日常を発信しています</p>
              </div>
            </div>
          </a>

          {/* 電話 */}
          <a
            href="tel:080-1752-6324"
            className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-200 cursor-pointer group"
          >
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-gray-100 rounded-full flex-shrink-0 group-hover:bg-yellow-50 transition-colors duration-300">
                <i className="ri-phone-fill text-3xl text-gray-600"></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-1">お電話</h3>
                <p className="text-sm text-gray-600">080-1752-6324</p>
                <p className="text-xs text-gray-500">※作業中は出られない場合があります</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
